import { IInitializeStorection } from '../../store/types'

export interface IUiState {
  loading: boolean
  error: string
  initialized: boolean
  message: message
}

export const INITIAL_STATE = 'ui/INITIAL_STATE'
export const INITIALIZE = 'ui/INITIALIZE'
export const INITIALIZE_SUCCESS = 'ui/INITIALIZE_SUCCESS'
export const INITIALIZE_FAILED = 'ui/INITIALIZE_FAILED'
export const ASYNC_START = 'ui/ASYNC_START'
export const ASYNC_FINISH = 'ui/ASYNC_FINISH'
export const ASYNC_ERROR = 'ui/ASYNC_ERROR'
export const CLEAR_STATE = 'ui/CLEAR_STATE'

export type message =
  | 'ERROR'
  | 'NONE'
  | 'INITIALIZED'
  | 'MY-CIRCLES-FETCHING'
  | 'MY-CIRCLES-FOUND'
  | 'MEMBER-ADD'
  | 'MEMBER-ADDED'
  | 'MEMBER-INVITE'
  | 'MEMBER-INVITED'
  | 'USER-FETCHING'
  | 'USER-FOUND'
  | 'USER-SIGN-IN'
  | 'USER-FORGOT-PASSWORD'
  | 'USER-FORGOT-PASSWORD-EMAIL-SENT'
  | 'USER-SIGN-UP'
  | 'USERNAME-CHECKING'
  | 'USERNAME-FOUND'
  | undefined

interface IInitialStateAction {
  type: typeof INITIAL_STATE
}

export interface IInitializeAction {
  type: typeof INITIALIZE
}

export interface IAsyncErrordAction {
  type: typeof ASYNC_ERROR
  error: string
}

export interface IAsyncStartAction {
  type: typeof ASYNC_START
  message?: message
}

export interface IAsyncFinishAction {
  type: typeof ASYNC_FINISH
  message?: message
}

export interface IClearStateAction {
  type: typeof CLEAR_STATE
}

export type UiActionTypes =
  | IInitializeStorection
  | IInitialStateAction
  | IInitializeAction
  | IAsyncStartAction
  | IAsyncFinishAction
  | IAsyncErrordAction
  | IClearStateAction
